import React, { createContext, useState } from "react";
import { IRolesContext } from "../types/roles";
import { UserRole } from "../types/settings";

export const RolesContext = createContext<null | IRolesContext>(null);

interface Props {
    children: React.ReactNode
}

export const RolesProvider: React.FC<Props> = ({ children }) => {    
    const [roles, setRoles] = useState<UserRole[]>([]);    

    const value: IRolesContext = {
        roles,
        setRoles
    };

    return (
        <RolesContext.Provider
            value={value}
        >
            {children}
        </RolesContext.Provider>
    );
};